import type { JTCodeSection } from "@/modules/corporate/types/sections"
import type { FunctionComponent } from "react"

import { Layout } from "@jobteaser/ui-kit/components/Layout/Layout"
import { TEXT_ALIGNS } from "@jobteaser/ui-kit/components/Text/Text"

import { Title } from "@/modules/corporate/components/Sections/Title/Title"
import { RichText } from "@/modules/kontent/components/RichText"

import styles from "./JTCode.module.css"

export type JTCodePropsType = {
  section: JTCodeSection
}

export const JTCode: FunctionComponent<JTCodePropsType> = ({ section }) => {
  const texts = [
    { firstLetter: "C", title: section.committedText },
    { firstLetter: "O", title: section.oneteamText },
    { firstLetter: "D", secondLetter: "E", title: section.drivenText },
  ]

  return (
    <section className={styles.main}>
      <Layout
        className={styles.wrapperHeader}
        style={{ "--backgroundImage": `url(${section.image[0].url})` } as React.CSSProperties}
      >
        <Layout.Column>
          <header className={styles.header}>
            <Title className={styles.title} title={section.title} tag="h2" isCentered />
            <RichText
              value={section.description}
              wrapperProps={{
                align: TEXT_ALIGNS.CENTER,
                className: styles.description,
                tag: "div",
              }}
            />
          </header>
        </Layout.Column>
      </Layout>
      <Layout className={styles.cardContainer}>
        <Layout.Column className={styles.columnWrapper}>
          <ul className={styles.list}>
            {texts.map(text => (
              <li key={`${text.firstLetter}_${text.secondLetter}`} className={styles.item}>
                <article
                  className={styles.card}
                  data-first-letter={text.firstLetter}
                  data-second-letter={text.secondLetter}
                >
                  <RichText
                    value={text.title}
                    wrapperProps={{
                      className: styles.description,
                      tag: "div",
                    }}
                  />
                </article>
              </li>
            ))}
          </ul>
        </Layout.Column>
      </Layout>
    </section>
  )
}
